import './style.scss';
import Schools from "./schools";
import React, {useState} from "react";
import {manageSchoolsItems, menuItems} from "../../constants";
import SubNavigationTabs from "../../components/common/subNavigationTabs";
import DistrictInfo from "./districtInfo";
import {useSelector} from "react-redux";

export const route = 'manage-schools';

const ManageSchools = () => {
  const addSchoolAlert = useSelector((state) => state.schools.addSchoolAlert);
  const editDistrictAlert = useSelector((state) => state.districts.editDistrictAlert);
  const [activeTab, setActiveTab] = useState((addSchoolAlert) ? 'schools' : 'district-info');

  const reportMenuItems = manageSchoolsItems.map((item) => {

    item['onClickAction'] = () => {
      setActiveTab(item.name);
    }

    return item;
  });

  return (
    <div className="reports-container">
      {<SubNavigationTabs items={reportMenuItems} currentTabName={activeTab}/>}
      {(activeTab === 'schools') ? <Schools addSchoolAlert={addSchoolAlert}/> : <DistrictInfo editDistrictAlert={editDistrictAlert}/>}
    </div>
  );
}

export default ManageSchools;

